import fileInputReader from "./file-input-reader";
import { ZengularNotification } from "zengular-ui";
/**
 * @param input
 * @param maxFileSize
 * @param target
 * @returns {Promise<string>}
 */

export default function fileChooser(input, maxFileSize, target) {
  return fileInputReader(input).dataURL(maxFileSize).then(function (result) {
    target.style.backgroundImage = 'url(' + result + ')';
    return true;
  }).catch(function (error) {
    switch (error.error) {
      case 'size':
        ZengularNotification.show(ZengularNotification.style.danger, 'fal fa-exclamation-square', 'Túl nagy fájlméret<small>Max: ' + error.allowed + 'bytes</small>');
        break;
    }

    return false;
  });
}